<template>
  <div>
    <van-row :gutter="10">
      <van-col :span="nums" v-for="(item,index) in lists" :key="index">
        <div
          :class="{'form-box-tag':true,'active':currentIndex==index ? true:false}"
          @click="swap(index,item)"
        >{{item}}</div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { Button, Icon, Row, Col, Tag } from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag
  },

  data() {
    return {
      isactive: true,
      currentIndex: -1,
      data: this.lists,
      searchValue: "",
     
    };
  },
  props: {
    nums: {
      type: Number,
      default: 6
    },
    select: {
      type: String,
      default: ""
    },
    lists: Array
  },

  mounted() {},
  watch: {
    select: function() {
      if (this.select != "") {
        var index = this.lists.indexOf(this.select);
        if (index > -1) {
          this.currentIndex = index;
        }
      }
    }
  },
  methods: {
    swap(index, value) {
      this.searchValue = value;
      this.currentIndex = index;
      this.$emit("change", value);
    }
  }
};
</script>

<style scoped>
.form-box-tag {
  background-color: #f8f8f8;
  line-height: 32px;
  text-align: center;
  color: #555;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
}
.form-box-tag.active {
  background-color: #feefe9;

  color: #f56229;
}
</style>>



